var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"demo__BubbleBlock always demo__pointer",class:{
    ['demo__height--' + _vm.height]: !!_vm.height,
    'demo__BubbleBlock--col-v2': !_vm.marginType,
    'demo__BubbleBlock--col': _vm.marginType === 'base',
    ['skeleton-' + _vm.bg]: _vm.demo,
    ['demo__border--' + _vm.border]: _vm.border ? true : false,
    ['demo__bg--' +
    (_vm.isMobile && _vm.bg === 'bgPlateDark' ? 'plateMobile' : _vm.bg)]: true,
    ['demo__color--' + _vm.color]: true,
  },on:{"click":function($event){_vm.clickPath ? _vm.$router.push(_vm.clickPath) : false}}},[(_vm.object.id)?_c('div',{staticClass:"demo__flex demo__flex-column demo__height-full 111",class:{
      ['demo__BubbleBlock_padding--v' + _vm.padding]: true,
    }},[(!_vm.noImage)?_c('div',{staticClass:"demo__flex demo__flex-space-around demo__relative"},[_c('img',{attrs:{"src":_vm.bgImage || '/404Serie.png'},on:{"error":(e) => {
            e.target.src = '/404Serie.png';
          }}})]):_vm._e(),(_vm.status)?_c('StatusBadge',{attrs:{"status":_vm.status,"position":"right-top"}}):_vm._e(),(!_vm.isSlot)?[_c('div',{staticClass:"demo__margin-top--10 demo__font--14 demo__weight--600 demo__font-mobile--16 demo__LikeAndCommentBlock--title"},[_vm._v(" "+_vm._s(_vm.title || _vm.object.title)+" ")]),_c('div',{staticClass:"demo__margin-top--10 demo__font--14 demo__font-mobile--14 demo__weight--400 demo__LikeAndCommentBlock--desc"},[(_vm.desc.mobiledoc)?_c('MobiledocText',{attrs:{"mobiledoc":_vm.object[_vm.desc.field],"just-string":true}}):_c('div',[_vm._v(" "+_vm._s(_vm.desc.value || _vm.object[_vm.desc.field])+" ")])],1),_c('div',{staticClass:"demo__flex demo__flex-bottom demo__font--13 demo__weight--600 demo__color--bgDescription"}),_c('div',{on:{"click":function($event){$event.stopPropagation();}}},[_c('BlockBottomReactions',{staticClass:"demo__margin-top--10",attrs:{"mode":"horizontal","object":_vm.object,"author":{
            ..._vm.object.author,
            initials: true,
            company: null,
          },"reactions":_vm.reactions,"css":{
            author: {
              font: {
                size: 12,
                weight: 600,
              },
            },
            reactions: {
              margin: 16,
              icon: {
                size: 14,
                margin: 6,
              },
              text: {
                size: 14,
                weight: 600,
              },
            },
          }}})],1)]:[_vm._t("default")]],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }